import React from 'react'

import { Link, GatsbyLinkProps } from 'gatsby'

import { QAHeader, QAPanel, QAContent, values } from '@karakuri-ai/faq-component'

import { Data, InformationLayoutProps } from './interface'

type Props = { data: Data; layout: InformationLayoutProps }
export function InformationWidget({ layout, data }: Props) {
  const informations = values(data.settingYaml.informations, [])
  if (!informations || informations.length === 0) {
    return null
  }
  return (
    <QAPanel className="faq-panel-information">
      <QAHeader title={`${layout.title || 'お知らせ'}`} />
      {informations.map(({ id, title }) => {
        if (!id || !title) {
          return null
        }
        const LinkComponent = React.forwardRef<
          HTMLAnchorElement,
          GatsbyLinkProps<Record<string, unknown>>
        >(function LinkComponent(props, ref) {
          return <Link ref={ref as any} {...props} to={`answer/${id}`} />
        })
        return <QAContent key={id} question={title} LinkComponent={LinkComponent} info />
      })}
    </QAPanel>
  )
}
